import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PublicBoxCosmeticBrandResponse } from './public-box-cosmetic-brand.response';

@jsonObject
export class PublicBoxCosmeticCollectionItemResponse {
  @jsonMember(String)
  public id!: Guid;

  @jsonMember(String)
  public name!: string;

  @jsonMember(String)
  public slug!: string;

  @jsonMember(PublicBoxCosmeticBrandResponse)
  public cosmeticBrand!: PublicBoxCosmeticBrandResponse;

  @jsonMember(MultimediaResponse)
  public featuredFile!: MultimediaResponse;
}
